import React, { useEffect } from "react";
import feather from "feather-icons";
import { Link } from "react-router-dom";

const Projects = () => {
  useEffect(() => {
    setTimeout(() => feather.replace(), 200);
  }, []);

  // === Données des projets ===
  const projects = [
    {
      icon: "book",
      color: "neonPink",
      title: "NEXORA Academy",
      desc: "A decentralized learning platform offering blockchain courses with NFT certification.",
      tags: ["Education", "Web3", "NFTs"],
      launch: "Q2 2026",
      link: "#",
    },
    {
      icon: "music",
      color: "neonBlue",
      title: "NEXORA Studio",
      desc: "A platform for emerging artists to mint and sell their work as NFTs with community funding.",
      tags: ["Art", "Music", "NFTs"],
      launch: "Q3 2026",
      link: "#",
    },
    {
      icon: "users",
      color: "neonPurple",
      title: "NEXORA DAO",
      desc: "A decentralized autonomous organization where NEXORA holders vote on funding youth initiatives.",
      tags: ["Governance", "DAO", "Voting"],
      launch: "Q4 2026",
      link: "#",
    },
    {
      icon: "heart",
      color: "neonPink",
      title: "NEXORA Wellness",
      desc: "Mental health resources and services with blockchain-based privacy and rewards.",
      tags: ["Health", "Wellness", "Privacy"],
      launch: "Q1 2027",
      link: "#",
    },
  ];

  return (
    <div className="text-white min-h-screen container mx-auto px-4 py-16 max-w-6xl">
      {/* === Header Section === */}
      <div className="text-center mb-16">
        <h1 className="text-5xl font-bold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-neonPink to-neonBlue">
          Upcoming Projects
        </h1>
        <p className="text-xl max-w-3xl mx-auto text-gray-300">
          Discover the exciting initiatives we're building for the next generation.
        </p>
      </div>

      {/* === Project Cards === */}
      <div className="grid md:grid-cols-2 gap-8 mb-16">
        {projects.map((proj) => (
          <div
            key={proj.title}
            className={`bg-gray-900/80 backdrop-blur-lg rounded-xl p-8 border border-${proj.color}/40 hover:border-${proj.color} transition-all duration-300 shadow-lg shadow-${proj.color}/10`}
          >
            <div className="flex items-center gap-4 mb-4">
              <div className={`text-${proj.color}`}>
                <i data-feather={proj.icon} className="w-8 h-8"></i>
              </div>
              <h2 className="text-2xl font-bold">{proj.title}</h2>
            </div>

            <p className="text-gray-300 mb-4">{proj.desc}</p>

            <div className="flex flex-wrap gap-2 mb-4">
              {proj.tags.map((tag) => (
                <span
                  key={tag}
                  className="text-xs bg-gray-800 px-2 py-1 rounded-full border border-gray-700 text-gray-300"
                >
                  {tag}
                </span>
              ))}
            </div>

            <div className="flex justify-between items-center text-sm">
              <span className="text-gray-400">Expected Launch: {proj.launch}</span>
              <a
                href={proj.link}
                className={`text-${proj.color} hover:underline transition-colors`}
              >
                Learn More
              </a>
            </div>
          </div>
        ))}
      </div>

      {/* === Submit Proposal Section === */}
      <div className="bg-gray-900/80 backdrop-blur-lg rounded-xl p-8 border border-neonBlue/40 text-center shadow-lg shadow-neonBlue/10">
        <h2 className="text-3xl font-bold mb-4 text-transparent bg-clip-text bg-gradient-to-r from-neonPink to-neonBlue">
          Have a project idea?
        </h2>
        <p className="text-xl max-w-2xl mx-auto mb-6 text-gray-300">
          We're always looking for innovative ideas that align with our mission to empower the next generation.
        </p>
        <Link
          to="/SubmitProposal"
          className="inline-block px-8 py-3 bg-gradient-to-r from-neonPurple to-neonPink rounded-lg font-bold text-lg hover:opacity-90 transition-all"
        >
          Submit Your Proposal
        </Link>
      </div>
    </div>
  );
};

export default Projects;
